import { ResultOf, VariablesOf, graphql } from "gql.tada";

const CancelAvailabilitySearchMutation = graphql(`
  mutation cancelAvailabilitySearch(
    $restaurantIds: [Int]!
    $date: String!
    $people: Int!
  ) {
    cancelAvailabilitySearch(
      restaurantIds: $restaurantIds
      date: $date
      people: $people
    ) {
      restaurantId
    }
  }
`);

export type QueryVariables = VariablesOf<
  typeof CancelAvailabilitySearchMutation
>;
export type QueryResult = ResultOf<typeof CancelAvailabilitySearchMutation>;

export default CancelAvailabilitySearchMutation;
